var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCartDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95814 5.43597L3.87619 9.59997H1.99814C0.965229 9.59997 0.120117 9.60645 0.120117 9.61437C0.120117 9.63307 3.16579 23.0387 3.18257 23.094C3.19471 23.1339 3.63549 23.136 12.0001 23.136C20.3647 23.136 20.8055 23.1339 20.8177 23.094C20.8344 23.0387 23.8801 9.63307 23.8801 9.61437C23.8801 9.60645 23.035 9.59997 22.0021 9.59997H20.124L18.0481 5.44615C16.9063 3.16154 15.9646 1.28748 15.9554 1.28155C15.9341 1.26777 14.6161 1.9254 14.6161 1.9498C14.6161 1.95984 15.4747 3.68522 16.5241 5.784L18.4321 9.59997H12.0001H5.56809L7.47609 5.784C8.52552 3.68522 9.38412 1.95984 9.38412 1.9498C9.38412 1.93389 8.08322 1.27197 8.052 1.27197C8.04544 1.27197 7.10323 3.14577 5.95814 5.43597ZM2.01612 11.1329C2.01612 11.1445 2.54587 13.4854 3.19337 16.3349C3.84084 19.1845 4.37678 21.5457 4.38437 21.582L4.39812 21.648H11.9988H19.5994L20.7922 16.398C21.4481 13.5105 21.9847 11.1399 21.9845 11.13C21.9839 11.1044 2.01612 11.1073 2.01612 11.1329Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartDefault);
export default __webpack_public_path__ + "static/media/shoppingCartDefault.79997f8f.svg";
export { ForwardRef as ReactComponent };